import React, { ReactElement } from 'react';

import { useConfigContext } from '@ott/config-context';

import { BaseMoney } from './blocks';
import type { BaseMoneyProps } from './blocks';

export type MoneyProps = BaseMoneyProps & { useOriginalMoney?: boolean; isRange?: boolean };

export const Money = (props: MoneyProps): ReactElement => {
  const { amount, useOriginalMoney, isRange, ...otherProps } = props;
  const config = useConfigContext();

  if (!__WHITE_LABEL__ || useOriginalMoney) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <BaseMoney {...props} />;
  }

  if (!config) {
    throw new Error(
      'Missing ConfigContextProvider  in rendered components hierarchy. ' +
        'To fix that, please add ConfigContextProvider with WhiteLabel config as parent in component tree.'
    );
  }

  const {
    moneyRate = null,
    moneyReplaceSymbol = '',
    moneyRangeReplaceSymbol = '',
    customCurrencyIconUrl = '',
  } = config;

  let symbolReplacer = moneyReplaceSymbol;
  if (isRange && moneyRangeReplaceSymbol) {
    symbolReplacer = moneyRangeReplaceSymbol;
  }
  let price = amount;
  if (moneyRate) {
    price = amount * moneyRate;
  }

  return (
    <BaseMoney
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...otherProps}
      amount={price}
      symbolReplacer={symbolReplacer}
      customCurrencyIconUrl={customCurrencyIconUrl}
    />
  );
};
